import { render, staticRenderFns } from "./sidebar-header.vue?vue&type=template&id=1c0f853a&scoped=true"
import script from "./sidebar-header.vue?vue&type=script&lang=js"
export * from "./sidebar-header.vue?vue&type=script&lang=js"
import style0 from "./sidebar-header.vue?vue&type=style&index=0&id=1c0f853a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f853a",
  null
  
)

export default component.exports